//Microsoft Edge has a visual images search that wen need to block so users on kiosk don't leave the planner
//TASK: Remove if Microsoft Edge removes the visual search feature as default

import { isKiosk } from 'utils/platform';

export const getPointerEventsValue = () => {
  if (isKiosk() && navigator.userAgent.indexOf('Edg') !== -1) {
    return 'none';
  } else {
    return 'auto';
  }
};
